import openSocket from 'socket.io-client';

const  socket = openSocket('https://serene-meadow-99603.herokuapp.com/');

function subscribeToTimer(cb) {
  socket.on('timer', timestamp => cb(null, timestamp));
  socket.emit('subscribeToTimer', 1000000);
}

function message(cb, theMessage, theName) {
  socket.on('message', obj => cb(null, obj));
  socket.emit('message', theMessage, theName);
}

function welcome(){
  socket.emit('welcome')
}

export { subscribeToTimer, message, welcome };